const on = new Proxy(
  {},
  {
    get: (_target, event) => {
      return (query) => (target, propertyKey) => {
        const connectedCallback = target.connectedCallback ?? (() => undefined);

        const disconnectedCallback =
          target.disconnectedCallback ?? (() => undefined);

        function listener(event) {
          event.target.matches(query) && this[propertyKey](event);
        }

        Reflect.defineProperty(target, "connectedCallback", {
          value() {
            this.shadowRoot.addEventListener(event, listener.bind(this));
            return Reflect.apply(connectedCallback, this, arguments);
          },
          writable: true,
        });

        Reflect.defineProperty(target, "disconnectedCallback", {
          value() {
            this.shadowRoot.removeEventListener(event, listener.bind(this));
            return Reflect.apply(disconnectedCallback, this, arguments);
          },
          writable: true,
        });
      };
    },
  },
);

export default on;
